var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Storage } from "../../../../lib/localstorege.service";
import { AccountTransactionApi } from "./account.transactions.api";
import { loginSubject, member } from "../../../../store/login.store";
import { useForm } from "react-hook-form";
import EmailUpdate from "../../widgets/modal/email.update";
import MobileUpdate from "../../widgets/modal/mobile.update";
import { modalServiceSubject } from "../../../../components/modal/modal";
import AvatarUpdate from "../../widgets/modal/update.avatar";
import { initialLeftMenu, sportsMenu, useForceUpdate } from "../../../../lib/misc.functions";
import { teamList } from '../../../../store/static.pages.store';
import CopyIcon from "../../../../assets/feather/copy.svg";
import { Link } from "react-router-dom";
import { professions } from "../../../../definitions/global.vars";
export default function MembershipInformation() {
    var _a;
    var forceUpdate = useForceUpdate();
    var token = Storage.get('token');
    var _b = useState(teamList), teamsList = _b[0], setTeamsList = _b[1];
    var _c = useState(true), isValidProfession = _c[0], setIsValidProfession = _c[1];
    var teamListData = {
        sport_type: 1,
        token: token
    };
    useEffect(function () {
        if (teamList.length < 1) {
            AccountTransactionApi.teamList(teamListData).then(function (result) {
                if (result.status) {
                    teamList.push.apply(teamList, result.data);
                    setTeamsList(result.data);
                }
                else {
                    modalServiceSubject.next({
                        title: "Hata!",
                        content: result.message,
                        confirm: {
                            cancel: { label: 'Tamam' }
                        },
                        timeout: 0
                    });
                }
            });
        }
    }, []);
    useEffect(function () {
        initialLeftMenu(false);
    }, [sportsMenu.isVisible]);
    useEffect(function () {
        var loginSubject_subscription = loginSubject.subscribe(function () {
            forceUpdate();
            reset({
                city: member.city,
                county: member.county,
                address: member.address,
                favorite_team: member.favorite_team_id,
                share_option: member.share_option,
                sms_notification: member.sms_notification,
                push_notification: member.push_notification,
                mail_notification: member.mail_notification,
                call_notification: member.call_notification,
                campaign_agreement: member.campaign_agreement,
            });
        });
        return function () {
            loginSubject_subscription.unsubscribe();
        };
    });
    var onSubmit = function (data) {
        updateMemberApi(data);
    };
    var updateMemberApi = function (data) {
        if (!isValidProfession)
            return;
        var requestMember = {
            city: data.city,
            address: data.address,
            county: data.county,
            sms_notification: data.sms_notification,
            push_notification: data.push_notification,
            mail_notification: data.mail_notification,
            call_notification: data.call_notification,
            campaign_agreement: data.campaign_agreement,
            token: token
        };
        if (data.profession != 9999) {
            // data boşsa member.profession'ı gönder, data varsa data'yı gönder
            if (data.profession === "" || data.profession === undefined || data.profession === null) {
                data.profession = member.profession;
            }
            requestMember['profession'] = data.profession;
        }
        var requestSosyoleyMember = {
            favorite_team: data.favorite_team,
            share_option: data.share_option,
            token: token,
        };
        try {
            AccountTransactionApi.updateMember(requestMember).then(function (result) {
                if (result.status) {
                    modalServiceSubject.next({
                        title: "Güncellendi!",
                        content: "Kayıt başarıyla güncellenmiştir.",
                        confirm: {
                            cancel: { label: 'Tamam' }
                        },
                        timeout: 0
                    });
                }
                else {
                    modalServiceSubject.next({
                        title: "Uyarı!",
                        content: result.message,
                        confirm: {
                            cancel: { label: 'Tamam' }
                        },
                        timeout: 0
                    });
                }
            });
            AccountTransactionApi.uptadeSosyoleyMember(requestSosyoleyMember).then(function (result) {
                if (result.status) {
                }
            });
        }
        catch (_a) {
            modalServiceSubject.next({
                title: "Uyarı!",
                content: "Beklenmedik bir hata oluştu.",
                confirm: {
                    cancel: { label: 'Tamam' }
                },
                timeout: 0
            });
        }
    };
    var _d = useForm(), register = _d.register, handleSubmit = _d.handleSubmit, _e = _d.formState, reset = _d.reset, setValue = _d.setValue;
    var getSelectedVal = function (value) {
        setValue('profession', value.id);
    };
    var getChanges = function (value) {
        // console.log("changes value:");
        // console.log(value);
    };
    return (_jsxs("div", __assign({ className: "card" }, { children: [_jsx("div", __assign({ className: "card-title" }, { children: _jsx("h2", { children: "\u00DCyelik Bilgilerim" }, void 0) }), void 0), _jsxs("div", __assign({ className: "card-body" }, { children: [_jsx(EmailUpdate, {}, void 0), _jsx(MobileUpdate, {}, void 0), _jsx(AvatarUpdate, {}, void 0), _jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit) }, { children: [_jsxs("div", __assign({ className: "table row " }, { children: [_jsxs("div", __assign({ className: "col-md-4 col-sm-12 mt-3" }, { children: [_jsx("label", { children: "\u0130l" }, void 0), _jsx("input", __assign({ className: "form-control", type: "text", defaultValue: member.city }, register('city')), void 0)] }), void 0), _jsxs("div", __assign({ className: "col-md-4 col-sm-12 mt-3" }, { children: [_jsx("label", { children: "\u0130l\u00E7e" }, void 0), _jsx("input", __assign({ className: "form-control", type: "text", defaultValue: member.county }, register('county')), void 0)] }), void 0), _jsxs("div", __assign({ className: "col-md-4 col-sm-12 mt-3" }, { children: [_jsx("label", { children: "Adres" }, void 0), _jsx("input", __assign({ className: "form-control", type: "text", defaultValue: member.address }, register('address')), void 0)] }), void 0)] }), void 0), _jsxs("div", __assign({ className: "table row mt-3" }, { children: [_jsx("div", __assign({ className: "col-sm-3" }, { children: _jsxs("label", { children: [" Takma ad\u0131n\u0131z: ", _jsx("i", { children: member.nick_name }, void 0)] }, void 0) }), void 0), _jsx("div", __assign({ className: "col-sm-9 " }, { children: _jsxs("i", { children: ["Kullan\u0131c\u0131 Ad\u0131n\u0131z (Kullan\u0131c\u0131 ad\u0131 ile ilgili herhangi bir sorun ya\u015F\u0131yorsan\u0131z ", _jsx(Link, __assign({ to: '/bize-yazin' }, { children: " Destek Talebi " }), void 0), "olu\u015Fturarak bize ula\u015Fabilirsiniz.)"] }, void 0) }), void 0)] }), void 0), _jsx("div", __assign({ className: "table row mt-3" }, { children: _jsxs("div", __assign({ className: "col-12" }, { children: [_jsx("label", { children: "Tak\u0131m" }, void 0), _jsx("div", { children: _jsxs("select", __assign({ className: "cursor-pointer" }, register('favorite_team'), { children: [_jsx("option", __assign({ value: member.favorite_team_id }, { children: teamsList.filter(function (team) { return (team.id === member.favorite_team_id); })[0] ? teamsList.filter(function (team) { return (team.id === member.favorite_team_id); })[0].name : null }), void 0), _jsx("option", __assign({ value: 0 }, { children: "Belirtmek \u0130stemiyorum" }), void 0), teamsList ? teamsList.map(function (team, key) {
                                                        return (_jsx("option", __assign({ value: team.id }, { children: team.name }), "sosyoleyOption" + key));
                                                    }) : null] }), void 0) }, void 0)] }), void 0) }), void 0), _jsx("div", __assign({ className: "table row mt-3" }, { children: _jsx("div", __assign({ className: "col-12" }, { children: _jsx(InputAuto, { label: "Meslek", pholder: member.profession !== null && member.profession !== undefined ? (_a = professions.find(function (profession) { return (profession.id === member.profession); })) === null || _a === void 0 ? void 0 : _a.name : "Meslek seçiniz", data: professions, onSelected: getSelectedVal, onChange: getChanges, isValid: isValidProfession, setIsValid: setIsValidProfession }, void 0) }), void 0) }), void 0), _jsx("div", __assign({ className: "table row mt-3" }, { children: _jsxs("div", __assign({ className: "col-sm-12" }, { children: [_jsx("div", __assign({ className: "form-control mt-3" }, { children: _jsxs("label", { children: [_jsx("input", __assign({ defaultChecked: member.share_option, type: "checkbox" }, register('share_option')), void 0), _jsx("span", __assign({ className: "cursor-pointer fw-normal" }, { children: "Yapt\u0131\u011F\u0131m kuponlar otomatik olarak SosyOley'de payla\u015F\u0131ls\u0131n.." }), void 0)] }, void 0) }), void 0), _jsx("div", __assign({ className: "form-control mt-3" }, { children: _jsxs("label", { children: [_jsx("input", __assign({ defaultChecked: member.sms_notification, type: "checkbox" }, register('sms_notification')), void 0), _jsx("span", __assign({ className: "cursor-pointer fw-normal" }, { children: "Oley.com taraf\u0131ndan SMS - k\u0131sa mesaj g\u00F6nderilmesini onayl\u0131yorum." }), void 0)] }, void 0) }), void 0), _jsx("div", __assign({ className: "form-control mt-3" }, { children: _jsxs("label", { children: [_jsx("input", __assign({ defaultChecked: member.push_notification, type: "checkbox" }, register('push_notification')), void 0), _jsx("span", __assign({ className: "cursor-pointer fw-normal" }, { children: "Oley.com taraf\u0131ndan Push bildirimi g\u00F6nderilmesini onayl\u0131yorum." }), void 0)] }, void 0) }), void 0), _jsx("div", __assign({ className: "form-control mt-3" }, { children: _jsxs("label", { children: [_jsx("input", __assign({ defaultChecked: member.mail_notification, type: "checkbox" }, register('mail_notification')), void 0), _jsx("span", __assign({ className: "cursor-pointer fw-normal" }, { children: "Oley.com taraf\u0131ndan E-posta g\u00F6nderilmesini onayl\u0131yorum." }), void 0)] }, void 0) }), void 0), _jsx("div", __assign({ className: "form-control mt-3" }, { children: _jsxs("label", { children: [_jsx("input", __assign({ defaultChecked: member.call_notification, type: "checkbox" }, register('call_notification')), void 0), _jsx("span", __assign({ className: "cursor-pointer fw-normal" }, { children: "Oley.com taraf\u0131ndan taraf\u0131ma arama yap\u0131lmas\u0131n\u0131 onayl\u0131yorum." }), void 0)] }, void 0) }), void 0), _jsx("div", __assign({ className: "form-control mt-3" }, { children: _jsxs("label", { children: [_jsx("input", __assign({ defaultChecked: member.campaign_agreement, type: "checkbox" }, register('campaign_agreement')), void 0), _jsx("span", __assign({ className: "cursor-pointer fw-normal" }, { children: "Hediyeler, kampanyalar ve bana \u00F6zel f\u0131rsatlardan haberdar olmak istiyorum." }), void 0)] }, void 0) }), void 0)] }), void 0) }), void 0), _jsx("div", __assign({ className: "table row mt-3" }, { children: _jsxs("div", __assign({ className: "col-12" }, { children: [_jsx("label", { children: "Referans Linki" }, void 0), _jsxs("div", __assign({ className: "form-control", onClick: function () {
                                                navigator.clipboard.writeText("https://oley.com/uye-ol?referer=" + member.id.toString(16).toUpperCase());
                                                document.execCommand('copy', true, "https://oley.com/uye-ol?referer=" + member.id.toString(16).toUpperCase());
                                                modalServiceSubject.next({
                                                    title: 'Referans linki kopyalandı',
                                                    content: "https://oley.com/uye-ol?referer=" + member.id.toString(16).toUpperCase(),
                                                    timeout: 3000,
                                                    confirm: {
                                                        cancel: {
                                                            label: 'Tamam'
                                                        }
                                                    }
                                                });
                                            } }, { children: ["https://oley.com/uye-ol?referer=", member.id.toString(16).toUpperCase(), _jsx("i", __assign({ className: "ml-2" }, { children: _jsx("img", { title: "Kopyala", src: CopyIcon, width: 16, height: 16 }, void 0) }), void 0)] }), void 0)] }), void 0) }), void 0), _jsx("input", { className: "btn btn-primary btn-large mt-3", type: "submit", value: "Kaydet" }, void 0)] }), void 0)] }), void 0), _jsx("div", { className: "card-footer" }, void 0)] }), void 0));
}
function InputAuto(_a) {
    var label = _a.label, pholder = _a.pholder, data = _a.data, onSelected = _a.onSelected, onChange = _a.onChange, isValid = _a.isValid, setIsValid = _a.setIsValid;
    var _b = useState([]), suggestions = _b[0], setSugesstions = _b[1];
    var _c = useState(true), isHideSuggs = _c[0], setIsHideSuggs = _c[1];
    var _d = useState(pholder), selectedVal = _d[0], setSelectedVal = _d[1];
    var handler = function (e) {
        setSugesstions(data.filter(function (i) {
            return i.name.toLocaleLowerCase('tr-TR').includes(e.target.value.toLocaleLowerCase('tr-TR'));
        }));
    };
    var handleChange = function (e) {
        var input = e.target.value;
        if (input.toString().length >= 2) {
            setIsHideSuggs(false);
        }
        else {
            setIsHideSuggs(true);
        }
        setSelectedVal(input);
        onChange(input);
    };
    var hideSuggs = function (value) {
        setSelectedVal(value.name);
        setIsHideSuggs(true);
        onSelected(value);
    };
    return (_jsxs("div", __assign({ className: "sugesstion-auto" }, { children: [_jsxs("div", __assign({ className: "form-control-auto" }, { children: [_jsx("label", __assign({ htmlFor: "tag-input" }, { children: label }), void 0), _jsx("input", { 
                        // placeholder={pholder}
                        type: "search", id: "input-auto", className: "form-control", value: selectedVal, autoComplete: "off", onChange: handleChange, onKeyUp: handler, onBlur: function () {
                            setTimeout(function () {
                                // @ts-ignore
                                var value = document.getElementById('input-auto').value;
                                var selectedValueIndex = data.findIndex(function (i) {
                                    return i.name.toLocaleLowerCase('tr-TR') == value.toLocaleLowerCase('tr-TR');
                                });
                                if (selectedValueIndex == -1) {
                                    setIsValid(false);
                                    setSelectedVal("");
                                }
                                else {
                                    setIsValid(true);
                                }
                                setIsHideSuggs(true);
                            }, 250);
                        } }, void 0), !isValid && _jsx("span", __assign({ className: "text-validation" }, { children: "L\u00FCtfen listeden bir meslek se\u00E7iniz." }), void 0)] }), void 0), _jsx("div", __assign({ className: "suggestions", style: { display: isHideSuggs ? "none" : "block" } }, { children: suggestions.map(function (item, idx) { return (_jsx("div", __assign({ onClick: function () {
                        hideSuggs(item);
                    } }, { children: item.name }), "" + item.id + idx)); }) }), void 0)] }), void 0));
}
